// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".duration-graph .col{border-left:2px dashed;height:55px;line-height:30px;padding:12px 0}.duration-graph .col:last-child{border-right:2px dashed}.duration-graph .col p{background-color:#d8d8d8;color:#000;font-size:11px;height:30px;text-align:center}.duration-graph .col p.active{background-color:#28d484}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
